import React, { FC } from 'react';
import ReactModal from 'react-modal';
import classNames from 'classnames';

import styles from './modal_full_screen.module.scss';

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  className?: string;
};

export const ModalFullScreen: FC<Props> = ({
  isOpen = false,
  className = '',
  children,
  onRequestClose,
}) => {
  const customProps = {
    closeTimeoutMS: 200,
    isOpen,
    onRequestClose,
    className: classNames(className, styles.container),
    overlayClassName: {
      base: styles.overlay,
      afterOpen: '',
      beforeClose: '',
    },
    ariaHideApp: false,
    bodyOpenClassName: styles.noBodyScroll,
  };

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <ReactModal {...customProps}>{children}</ReactModal>;
};
